import {
  Department as DepartmentType,
  DepartmentTable,
} from "@/app/types/department";
import { apiSlice } from "@/features/api/ApiSlice";

export const Department = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getDepartments: builder.query<DepartmentTable, { query: string }>({
        query: ({ query }) => ({
          url: `/department?${query}`,
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }),
        providesTags: [{ type: "Department", id: "LIST" }],
      }),
      getDepartmentList: builder.query<
        { value: number; label: string }[],
        void
      >({
        query: () => ({
          url: `/department`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Department"],
        transformResponse: (resp: { data: { id: number; name: string }[] }) => {
          return resp.data.map((department: { id: number; name: string }) => ({
            value: department.id,
            label: `${department.name}`,
          }));
        },
      }),
      createDepartment: builder.mutation<
        DepartmentType,
        Partial<DepartmentType>
      >({
        query: (body) => ({
          url: "/department",
          method: "POST",
          body,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }),
        invalidatesTags: [{ type: "Department", id: "LIST" }],
      }),
      updateDepartment: builder.mutation<
        DepartmentType,
        Partial<DepartmentType>
      >({
        query: (body) => ({
          url: `/department/${body.id}`,
          method: "PUT",
          body,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }),
        invalidatesTags: [{ type: "Department", id: "LIST" }],
      }),
      deleteDepartment: builder.mutation<
        DepartmentType,
        Partial<DepartmentType>
      >({
        query: (body) => ({
          url: `/department/${body.id}`,
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: [{ type: "Department", id: "LIST" }],
      }),
      uploadImage: builder.mutation({
        query: (file) => {
          const formData = new FormData();
          formData.append("logo", file);
          return {
            url: "minio/upload",
            method: "POST",
            body: formData,
          };
        },
      }),
      deleteImage: builder.mutation({
        query: ({ url }) => ({
          url: `/minio/delete?url=${encodeURIComponent(url)}`,
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }),
      }),
      getDepartmentById: builder.query<DepartmentType, number>({
        query: (data) => ({
          url: `/department/${data}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
      }),
    };
  },
});

export const {
  useGetDepartmentsQuery,
  useGetDepartmentListQuery,
  useCreateDepartmentMutation,
  useUpdateDepartmentMutation,
  useDeleteDepartmentMutation,
  useUploadImageMutation,
  useDeleteImageMutation,
  useGetDepartmentByIdQuery
} = Department;
